import { render, staticRenderFns } from "./IconArrowDown.vue?vue&type=template&id=060b8a5c&scoped=true&"
import script from "./IconArrowDown.vue?vue&type=script&lang=js&"
export * from "./IconArrowDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060b8a5c",
  null
  
)

export default component.exports